import React from 'react';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { whatsappNumber, whatsappMessage } from '../data/mock';

const CTA = () => {
  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="contact" className="cta-section">
      <div className="cta-content">
        <div className="cta-background-effect"></div>
        
        <div className="cta-text-container">
          <h2 className="cta-title">
            Tu negocio merece una web profesional
          </h2>
          <p className="cta-subtitle">
            Si tu negocio aún no tiene página web, es el momento de dar el siguiente paso. 
            Contactanos hoy y descubre cómo podemos ayudarte a crecer.
          </p>
          
          <div className="cta-buttons">
            <button onClick={handleWhatsAppClick} className="btn-primary-large">
              <MessageCircle size={24} />
              Contactar ahora por WhatsApp
              <ArrowRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
